/**
 * Reads a boolean out of a backend config value.
 *
 * A `config` row's value is a VARCHAR, so it arrives as whatever was stored — and the
 * trap is that `"false"` is a truthy string, so `Boolean(value)` would turn every
 * switched-off flag on. The accepted spellings match what the backend accepts
 * (`DataStoreSharePolicy` on the service side), because a parameter that means one thing
 * to the UI and another to the service it guards is worse than no parameter.
 *
 * Anything unrecognized is false: for a parameter that opens one organization's data
 * to another, "I could not read this" has to resolve the same way as "no".
 */
export function isConfigTrue(value: unknown): boolean {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  return trimmed.toLowerCase() === "true" || trimmed === "1";
}
